module.exports = __webpack_public_path__ + "img/menu_icon.6f80f56f.svg";